import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
import { getCometSource } from '#pplx/frontend/comet/client/utils.js';
import { ANDROID_SOURCE, IOS_SOURCE, WINDOWS_APP_SOURCE, } from '#pplx/frontend/components/utils/consts.js';
import { MWEB_SOURCE, WEB_SOURCE } from '#pplx/frontend/fetcher/constants.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
const getSourceFromDeviceInfo = (args) => {
    if (args.isWindowsApp) {
        return WINDOWS_APP_SOURCE;
    }
    if (isMaybeIncognitoComet()) {
        return getCometSource();
    }
    if (args.isIOS) {
        return IOS_SOURCE;
    }
    if (args.isAndroid) {
        return ANDROID_SOURCE;
    }
    if (args.isMobile) {
        return MWEB_SOURCE;
    }
    return WEB_SOURCE;
};
export const useVoiceSource = () => {
    const { device: { isWindowsApp, isIOS, isAndroid, isMobile }, } = useWebPlatform();
    return getSourceFromDeviceInfo({
        isWindowsApp,
        isIOS,
        isAndroid,
        isMobile,
    });
};
//# sourceMappingURL=source.js.map